<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                {{form.nome}}
                <v-chip class="mx-2" title="Turma" label color="grey">{{aluno.codturma}}</v-chip>
                <v-chip class="mx-2" title="Série" label color="info">{{aluno.habilitacao}}</v-chip>
            </v-card-title>
            <v-card-subtitle>
                Você está vinculando uma nova lista relacionada ao período letivo {{aluno.codperlet}}
            </v-card-subtitle>
        </v-card>
        <v-row>
            <v-col cols="12" sm="7">
                <v-select clearable
                    placeholder="Selecione uma Lista..."
                    :items="listas"
                    @update:modelValue="createListaAluno"
                    return-object
                    :item-title="(v) => `${v.codperlet} - ${v.titulo}`"
                    :messages="`Se a lista desejada não aparece entre as opções verifique se a mesma foi cadastrada no período letivo ${aluno.codperlet}`"
                >
                    <template v-slot:append-outer>
                        <v-btn icon title="Atualizar listas" class="mr-1"
                            :loading="$store.state.checklistdb.loading_id === 'get-checklists'"
                            @click="atualizaListas">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <helper-gdb text="AdicionarListaAluno" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
    </div>
</template>
<script>
/* eslint-disable */
import { mapActions } from 'vuex'
export default {
    props: {
        form: {
            required: true
        },
        aluno: {
            required: true
        }
    },
    data: () => ({
        listas: [],
    }),
    mounted(){
        this.atualizaListas()
    },
    methods: {
        ...mapActions(['CreateCheckListAlunoLista', 'GetCheckLists']),
        async atualizaListas(){
            this.listas = await this.GetCheckLists({ codperlet: this.aluno.codperlet })
        },
        async createListaAluno(option){
            if (!option) return
            const confirma = confirm(`Confirmar o vínculo da lista ${option.titulo} para o aluno ${this.aluno.ra} - ${this.aluno.nome}?`)
            if (!confirma) return
            this.form.lista = option.id
            const created = await this.CreateCheckListAlunoLista(this.form)
            this.$emit('on-created', created)
        }
    },
    computed: {
    },
    watch: {
        // propObject:{
        //     handler(value){
        //         const prop = value
        //         this.form = prop
        //     }, deep: true
        // }
    }
}
</script>